import { useTranslate } from "ra-core";

import { TasksListContent } from "./TasksListContent";

export const DesktopTasksList = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold tracking-tight">
        {translate("resources.tasks.name", { smart_count: 2 })}
      </h1>
      <TasksListContent />
    </div>
  );
};
